// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LifeBuoy as RawLifeBuoy } from "lucide-react";
export const LifeBuoy = /* @__PURE__ */ createIcon(RawLifeBuoy, "LifeBuoy", 2);
